import {createRouter, createWebHistory, type RouteRecordRaw} from 'vue-router';

import {authenticationGuard} from "@shared/guards";
import {exceptionsRoutes} from "@domains/exceptions";
import {dashboardRoutes} from "@domains/dashboard";
import {accountRoutes} from "@domains/account";
import {settingRoutes} from "@domains/settings";
import {authenticationRoutes} from "@domains/auth";
import {boardsRoutes} from "@domains/boards";
import {publishRoutes} from "@domains/publish";
import {marketRoutes} from "@domains/marketplace";
import {agentTestRoutes} from "@domains/agent-test";
import {llmAuditRoutes} from "@domains/llm-audit";
import {uiKitRoutes} from "@domains/ui-kit";
import {config} from "@/config";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/dashboard'
  },
  {
    path: '/publish-tiptap-playground',
    name: 'tiptap-playground',
    component: () => import('@domains/exceptions/views/tiptap-playground.view.vue'),
    meta: {requiresAuth: false},
  },
  ...exceptionsRoutes,
    ...authenticationRoutes,
  ...dashboardRoutes,
  ...accountRoutes,
  ...settingRoutes,
  ...boardsRoutes,
  ...publishRoutes,
  ...marketRoutes,
  ...agentTestRoutes,
  ...llmAuditRoutes,
  // Dev-only styleguide (/ui/*): production'da route hiç kaydedilmez → 404
  ...(config('APP_MODE') !== 'production' ? uiKitRoutes : [])
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  authenticationGuard(to, from, next)
});

export default router;
